import { Tab, TabList, Tabs, } from "@chakra-ui/react";

interface CustomTagsProps {

    choices: string[],
    results: string[],
    
    value : string,
    onChange : (v:string) => void;
    
}


const CustomTabsMultiple = ({value,onChange,choices,results}:CustomTagsProps) => {

    const selectedTabs : string[] = value.split(',').filter(item => item !== "");

    const handleTabClick = (index : number) => {


        if (selectedTabs.includes(results[index])) {

            const newSelectedTabs : string[] = selectedTabs.filter((selectedTab : string) => selectedTab !== results[index]);
            onChange(newSelectedTabs.join(','));

        } else {
            const newSelectedTabs : string[] = [...selectedTabs, results[index]];
            onChange(newSelectedTabs.join(','));
        }
        
      };

    return <Tabs  size='sm' variant="unstyled">
        <TabList flexWrap='wrap' gap='6px'>

            {choices.map((v:string,i:number) => {

                const isSelected = selectedTabs.includes(results[i])

                return <Tab
                fontWeight='400'
                bg={isSelected ? 'black' : 'transparent'}
                h='32px'
                color={isSelected ? "white" : 'black'}
                borderRadius="50px"
                _active={{ bg:'black' }}
                border={isSelected ? '1px solid #171C22' : '1px solid #DCE2EA'}
                onClick={() => handleTabClick(i)}

                >{v}</Tab>
            })}

        </TabList>
    </Tabs>
}

export default CustomTabsMultiple;